import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { putRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/AutoAcceptance/messages';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

const acceptSuggestion = async (resultId: number) => {
  const { data } = await putRequest(API.PUT.acceptSuggestion(resultId));
  return data;
};

export const useAcceptSuggestion = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: acceptSuggestion,
    onSuccess: () => {
      // client.invalidateQueries({
      //   queryKey: [QUERY_KEYS.AUTO_ACCEPTANCE_RESULTS],
      // });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS_COUNT],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOB_APPLICATIONS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.CALENDAR_JOBS],
      });
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.JOBS],
      });
      handleSuccess(formatMessage(messages.suggestionAccepted));
    },
    onError: handleError,
  });
};
